@if (hasAnything()) {
  <div class="gateway-block">
    <div class="gateway-item">
      <span class="gateway-item-label" i18n="@@telecomAccount.gateway.addresses">Endpoints</span>
      <div class="gateway-ips">
        @for (addr of addresses(); track addr) {
          <div class="gateway-row">
            <code class="gateway-url">{{ addr }}</code>
            <p-button
              icon="pi pi-copy"
              [text]="true"
              size="small"
              severity="secondary"
              i18n-pTooltip="@@common.copy"
              pTooltip="Copy"
              tooltipPosition="top"
              (click)="copyText(addr)">
            </p-button>
          </div>
        }
      </div>
      <div class="gateway-hint" i18n="@@telecomAccount.gateway.hint">
        Point your SIP provider's INVITE destination at one of these endpoints (any works; DNS-name is safer against IP changes).
      </div>
    </div>
  </div>
}
